import React, { useState } from "react";
import { FiLock, FiCheckCircle, FiX } from "react-icons/fi";
import { isMobile } from "../utilities/functions";
import { getInfo } from "../utilities/calls";

export default function PremiumGateModal({ open, onClose, onSubmit, url }) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit =  () => {
    try {
      setLoading(true);
        const to = encodeURIComponent('admin@justwhere.io');
        const subject = encodeURIComponent("Request for Premium Feature Access");
        const loggedInUser = decodeURIComponent(getInfo("UserID"));
        const body = encodeURIComponent(`Hello,

I would like to request access to premium features on my account.

My registered email: ${loggedInUser}

I was trying to access ${url}.

Please let me know the next steps.

Thank you.`
        );
        var link = isMobile() ? "mailto:" + to + "?subject=" + subject + "&body=" + body :
            "https://mail.google.com/mail/u/0/?fs=1&tf=cm&to=" + to + "&su=" + subject + "&body=" + body;
        const a = document.createElement("a"); a.setAttribute('href', link); a.setAttribute('target', '_blank'); a.click();
      onSubmit?.();
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm">
      
      <div className="w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl bg-zinc-900 border border-teal-800/40 shadow-2xl p-6 relative animate-slideUp">
        
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-zinc-500 hover:text-white"
        >
          <FiX size={20} />
        </button>

        {!submitted ? (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-zinc-800">
                <FiLock className="text-teal-400" size={24} />
              </div>
            </div>

            <h2 className="text-lg sm:text-xl font-semibold text-white text-center mb-2">
              Unlock Premium Feature
            </h2>

            <p className="text-sm text-zinc-400 text-center mb-6">
              This feature is part of our Premium tier.
              Contact us to enable advanced capabilities for your account.
            </p>

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full bg-gradient-to-r from-teal-600 to-teal-500  hover:bg-teal-500 disabled:opacity-50 text-white py-3 rounded-xl font-medium transition"
            >
              {loading ? "Submitting..." : "Request Premium Access"}
            </button>

            <button
              onClick={onClose}
              className="w-full mt-3 text-sm text-zinc-500 hover:text-zinc-300"
            >
              Maybe Later
            </button>
          </>
        ) : (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-900/40">
                <FiCheckCircle className="text-green-400" size={26} />
              </div>
            </div>

            <h2 className="text-lg sm:text-xl font-semibold text-white text-center mb-2">
              Thank You!
            </h2>

            <p className="text-sm text-zinc-400 text-center mb-6">
              Our team will contact you soon.
            </p>

            <button
              onClick={onClose}
              className="w-full bg-zinc-800 hover:bg-zinc-700 text-white py-3 rounded-xl"
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
}